import React, { FC } from 'react';
import clsx from 'clsx';
import { Typography } from '@mui/material';
import { useViewport } from '../../../../hooks';

export const PanelTitle: FC<Props> = ({ title, className }: Props) => {
  const isMobile = useViewport('sm');
  return (
    <Typography
      variant={isMobile ? 'body2' : 'subtitle1'}
      fontWeight="bold"
      className="bg-gradient-to-br from-portal-teal to-portal-seagreen bg-clip-text text-transparent"
    >
      {title}
    </Typography>
  );
};

interface Props {
  title: string;
  className?: string;
}
